function formatProps(props) {
  const result = {};
  for (const key in props) {
    const pascalCaseKey = key.replace(
      /-([a-z])/g,
      (_match, letter) => letter.toUpperCase()
    );
    result[pascalCaseKey] = props[key];
  }
  return result;
}
export {
  formatProps
};
//# sourceMappingURL=format-props.js.map
